
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"12","height":"19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 17.408V7.592H9.026V6.5H12v11.998H0V6.501h3.023v1.09H1.001v9.817h9.998zm-8.272-12.7l-.705-.705L6.025 0l4.003 4.003-.71.71-2.793-2.797v10.515h-1V1.916L2.728 4.708z"}})])
      }
    
      }
    